import { useState, type FormEvent } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { submitXianyu } from '../lib/api';

export default function SubmitXianyu() {
  const { code = '' } = useParams();
  const navigate = useNavigate();
  const [no, setNo] = useState('');
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState('');

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    const trimmed = no.trim();
    if (trimmed.length < 6) {
      setError('请填写至少 6 位的闲鱼订单号');
      return;
    }
    setBusy(true);
    setError('');
    try {
      await submitXianyu(code, trimmed);
      setDone(true);
    } catch (err) {
      setError(err instanceof Error ? err.message : '提交失败');
    } finally {
      setBusy(false);
    }
  }

  if (done) {
    return (
      <section className="stack">
        <div className="work-card">
          <h2 className="type-display-md text-ink">已提交，等待确认</h2>
          <p className="type-body-md text-ink">
            我们已收到闲鱼订单号。管理员核对闲鱼后台后会将订单标记为已支付，届时即可进入创作室。
          </p>
          <p className="type-body-md text-ink-secondary">通常在工作时间内完成核对，请稍后刷新订单状态。</p>
        </div>
        <div className="row">
          <Link className="btn-primary" to={`/order/${code}`}>
            查看订单状态
          </Link>
          <button type="button" className="btn-secondary" onClick={() => navigate(`/order/${code}/studio`)}>
            前往创作室
          </button>
        </div>
      </section>
    );
  }

  return (
    <section className="stack">
      <div className="work-card">
        <h2 className="type-display-md text-ink">提交闲鱼订单号</h2>
        <p className="type-body-md text-ink-secondary">
          站内订单号 <span className="mono">{code}</span>。请填写闲鱼后台可见的订单编号（至少 6
          位）。
        </p>
        <form className="stack" onSubmit={onSubmit}>
          <label className="field">
            闲鱼订单号
            <input
              className="form-control"
              type="text"
              value={no}
              onChange={(e) => setNo(e.target.value)}
              placeholder="例如 123456789012345"
              autoComplete="off"
            />
          </label>
          {error ? <div className="error">{error}</div> : null}
          <div className="row">
            <button className="btn-primary" type="submit" disabled={busy}>
              {busy ? '提交中…' : '提交'}
            </button>
            <Link className="btn-secondary" to={`/order/${code}/pay`}>
              返回支付指引
            </Link>
          </div>
        </form>
      </div>
    </section>
  );
}
